module.exports = __webpack_public_path__ + "img/south_african_airways_logo.0422e4df.svg";